import React from "react";
import "./loadingSmall.scss";
const LoadingSmall = () => {
  return <div className="loading"></div>;
};

export default LoadingSmall;
